module.exports = __webpack_public_path__ + "static/media/37.7cf31104.png";